/**
 * Coaching session status constants
 */
export const COACHING_SESSION_STATUS = {
    NEW: "New",
    ACTIVE: "Active",
    COMPLETED: "Completed"
} as const;

/**
 * Sentinel key for not-yet-created NEW session's pending work (comments, completion).
 * This key in state.coaching[userId].comments and .pendingCompletions represents
 * offline work for a session that hasn't been Created on the server yet.
 * Matches the route id used by navigateToCoachingSession("new").
 */
export const NEW_SESSION_KEY = "new";

/**
 * Shared root prefix on every coaching-sync log line. Grep `[CoachingSync]` to follow the whole
 * flow in order across the orchestrator and its collaborators; each stage appends its own sub-tag
 * (e.g. `[CoachingSync] [Comment]`) so you can still tell which step emitted a line.
 */
export const COACHING_SYNC_LOG_PREFIX = "[CoachingSync]";

// Built-in rule ids for GPS harsh events. Only these get a speed change indicator; the
// braking id also sets the direction (deceleration vs acceleration) in computeSpeedChange.
export const HARSH_BRAKING_RULE_ID = "RuleHarshGpsBrakingId";
export const HARSH_ACCELERATION_RULE_ID = "RuleHarshGpsAccelerationId";
export const HARSH_EVENT_RULE_IDS: string[] = [HARSH_BRAKING_RULE_ID, HARSH_ACCELERATION_RULE_ID];

export const isHarshEventRule = (ruleId: string | undefined): boolean =>
    HARSH_EVENT_RULE_IDS.indexOf(ruleId ?? "") !== -1;
